import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationFullCreatorApplicationDeclined.vue";

export const selector = (item: Notification): boolean => {
  return item.type === NotificationType.FULL_CREATOR_APPLICATION_DECLINED;
};
